// Complete Nursery Inventory - AGreenerSide
export const nurseryProducts = [
  // ========================================
  // VEGETABLE TRANSPLANTS & PLUGS
  // ========================================
  {
    id: 2,
    name: "72-Cell Annual Transplants",
    scientificName: "Various Species",
    category: "Annual",
    price: 0.50,
    size: "1.5\" (50¢ each)",
    description: "Annual herbs, flowers and veggies in 72-cell plug trays. Perfect for starting your garden or filling beds. Available weeks 12-16.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/ufa1vbpu_1000001500.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/brpk73ig_PXL_20240408_143242737.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/2l2m7gld_PXL_20240402_163027415.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/oc6kgfsx_PXL_20240426_114833606.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/bsd31f62_PXL_20240318_133220788.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/3906lwsr_PXL_20240307_143811477.MP.jpg"
    ],
    imageCaption: ["Seedling plug trays", "Hot pepper plugs", "Coleus plugs", "Strawflower florist series", "Sweet pepper plugs", "Tomato plugs"],
    inStock: true,
    growingZones: "All Zones",
    sunRequirement: "Varies",
    matureHeight: "Varies"
  },
  {
    id: 100,
    name: "72-Cell Perennial Transplants",
    scientificName: "Various Species",
    category: "Annual",
    price: 1.00,
    size: "1.5\" ($1 each)",
    description: "Perennial flowers and herbs in 72-cell plug trays. Hardy plants that return year after year. Available weeks 12-16.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/ufa1vbpu_1000001500.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/brpk73ig_PXL_20240408_143242737.jpg"
    ],
    imageCaption: ["Perennial plug trays", "Herb plugs"],
    inStock: true,
    growingZones: "Varies",
    sunRequirement: "Varies",
    matureHeight: "Varies"
  },
  {
    id: 4,
    name: "Annual Herbs & Flowers",
    scientificName: "Various Species",
    category: "Annual",
    price: 3.00,
    size: "2.25\" & 3.5\" Pots",
    description: "Annual herbs including basil varieties (holy, purple, sweet, Thai), cilantro, dill, and more. Available weeks 16-24.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/mtgv8mtn_PXL_20240525_222514365.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/vkxi7mgh_PXL_20240509_140619458.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/x4hc64i6_PXL_20250405_173950418.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/af3eib31_8501b860-1250-4062-a13d-1066dbad5da4-1_all_64.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/itn7ru0z_1000004284.png",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/89hjui0q_1000004316.png"
    ],
    imageCaption: ["Herb collection", "Basil varieties", "Cut flower selections", "Coleus varieties", "Celosia Red Raven almost filled out and ready to go in April", "Ice plant flowers with celosia - vibrant colors for your garden"],
    inStock: true,
    growingZones: "All Zones",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "Varies"
  },
  {
    id: 1,
    name: "Vegetable Transplants",
    scientificName: "Various Species",
    category: "Annual",
    price: 5.00,
    size: "3.5\" & 4-packs ($5 ea / 10 for $45)",
    description: "Seasonally available vegetable starts including tomatoes, peppers, squash, cucumbers, and more. Organically grown and ready for your garden. Available weeks 16-28.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/pjmfpfa2_PXL_20240412_111402637.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/cfy1yqdl_PXL_20240412_111342655.jpg",
      "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/ohxfwyjy_PXL_20240509_135747326.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/akg9efmk_FB_IMG_1744596968903.jpg",
      "https://customer-assets.emergentagent.com/job_agrside/artifacts/425wfvec_1000004514.png",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/z7wvkb1m_1000004068.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/bwfaxftu_1000004070.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/axxcynu8_1000004074.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/mddz6lwa_1000004076.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/lmuzvkd7_1000004073.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/7p4oze5x_1000004072.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/mibu8k2v_1000004067.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/r8b6ocyx_1000004087.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/aio3om25_1000004089.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/yemby7tc_1000004094.webp"
    ],
    imageCaption: ["Tomato transplants", "Hot pepper starts", "Hyacinth bean", "Potted vegetables", "Bloody Dock - edible perennial", "Dester heirloom tomato", "Heirloom tomato harvest", "Pink Ox Heart tomato", "Orange Hat tomato", "Sakura cherry tomatoes", "Contessa tomato", "Pink Jazz tomato", "Candy Cane bell pepper", "Jigsaw pepper", "Kaddi mirchi"],
    inStock: true,
    growingZones: "All Zones",
    sunRequirement: "Full Sun",
    matureHeight: "Varies"
  },
  {
    id: 3,
    name: "Perennial Herbs",
    scientificName: "Various Species",
    category: "Annual",
    price: 7.00,
    size: "Quart Pot",
    description: "Hardy perennial herbs including rosemary, sage, thyme, oregano, and lavender. Return year after year with proper care.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/mtgv8mtn_PXL_20240525_222514365.jpg",
    inStock: true,
    growingZones: "4-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "6-24 inches"
  },
  {
    id: 5,
    name: "Black & Variegated Cotton",
    scientificName: "Gossypium herbaceum",
    category: "Annual",
    price: 12.00,
    size: "6\" Pot",
    description: "Stunning ornamental cotton varieties with dramatic deep purple-black or variegated foliage. Produces pink hibiscus-like flowers followed by cotton bolls.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/xzdnhioc_FB_IMG_1769679200448.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/g5m78y4t_PXL_20250925_202202571.MP.jpg"
    ],
    imageCaption: ["Black leafed cotton", "Variegated cotton"],
    inStock: true,
    growingZones: "8-11",
    sunRequirement: "Full Sun",
    matureHeight: "3-4 feet"
  },

  // ========================================
  // PEPPERS - HOT & SWEET
  // ========================================
  {
    id: 103,
    name: "Balloon Flower 'Axminster Streaked'",
    scientificName: "Platycodon grandiflorus 'Axminster Streaked'",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Stunning streaked blue and white balloon-shaped buds open to star-shaped flowers. Medicinal root used in traditional medicine. Long-blooming and deer resistant.",
    image: "https://customer-assets.emergentagent.com/job_agrside/artifacts/2edy18bc_1000004517.jpg",
    inStock: true,
    growingZones: "3-8",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "1-2 feet"
  },
  {
    id: 9,
    name: "Native Columbine",
    scientificName: "Aquilegia canadensis",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Beautiful native wildflower with delicate red and yellow blooms. Attracts hummingbirds and butterflies. Be the first to know when the hummingbirds migrate back as this blooms symbiotically with their return!",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/p8csd8cy_1000004197.png",
    inStock: true,
    growingZones: "3-8",
    sunRequirement: "Partial Shade",
    matureHeight: "1-2 feet"
  },
  {
    id: 102,
    name: "Variegated Joe Pye Weed",
    scientificName: "Eupatorium aromaticum 'Joicus'",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Stunning variegated native perennial with cream and green foliage. Fragrant white flower clusters attract butterflies and pollinators in late summer.",
    image: [
      "https://customer-assets.emergentagent.com/job_agrside/artifacts/lixt8s5n_1000004515.png",
      "https://customer-assets.emergentagent.com/job_agrside/artifacts/uah1z4er_1000004516.png"
    ],
    imageCaption: ["Variegated foliage", "Cream and green leaves"],
    inStock: true,
    growingZones: "4-8",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "3-4 feet"
  },
  {
    id: 10,
    name: "Japanese Variegated Iris",
    scientificName: "Iris ensata",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Stunning variegated foliage with elegant purple blooms. A showstopper in any garden setting, especially beautiful near water features.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/e8devw4u_1000004196.png",
    inStock: true,
    growingZones: "4-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "2-3 feet"
  },
  {
    id: 11,
    name: "Canna Lilies",
    scientificName: "Canna indica",
    category: "Hardy Tropical",
    price: 15.00,
    size: "1 Gallon Pot",
    price: 15.00,
    description: "Tropical beauty in yellow, orange, or red. Bold foliage and vibrant flowers add drama to any landscape.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/p27lwe4h_Canna-generalis-Stuttgart.i-1972.s-60933.r-1~2.jpg",
    inStock: true,
    growingZones: "7-10",
    sunRequirement: "Full Sun",
    matureHeight: "3-6 feet"
  },
  {
    id: 12,
    name: "Daylilies Collection",
    scientificName: "Hemerocallis hybrids",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Red, purple, and double varieties available. Edible and beautiful - the flowers make a stunning addition to salads! Easy care and long-blooming.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/bt45iu8o_PXL_20250627_154254310.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/2ehcb5vw_8501b860-1250-4062-a13d-1066dbad5da4-1_all_2331.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/gvp4b3i8_8501b860-1250-4062-a13d-1066dbad5da4-1_all_1249.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/jis0i1d7_1000000436.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/3xnb3jmb_1000004298.png"
    ],
    imageCaption: ["Daylilies - edible and beautiful!", "Vibrant daylily blooms in the garden", "Orange daylily in full bloom", "Dark red daylily", "Peach daylily in full bloom"],
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "1-3 feet"
  },
  {
    id: 82,
    name: "Daphne Perfume Princess",
    scientificName: "Daphne × transatlantica",
    category: "Shrub",
    price: 45.00,
    size: "3 Gallon Pot",
    description: "Intensely fragrant! Clusters of pink-white blooms perfume the garden from spring through fall. Evergreen foliage year-round.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/nt8r6to3_1000004025.jpg",
    inStock: true,
    growingZones: "6-9",
    sunRequirement: "Partial Shade",
    matureHeight: "3-4 feet"
  },
  {
    id: 13,
    name: "Poet's Laurel",
    scientificName: "Danae racemosa",
    category: "Perennial",
    price: 40.00,
    size: "3 Gallon Pot",
    description: "Elegant evergreen shrub with graceful arching branches and curious edible red berries. Steeped in mythical tradition - the ancient Greeks wove these branches into laurel crowns to honor poets and scholars. Create your own piece of history!",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/848andds_1000004198.jpg",
    inStock: true,
    growingZones: "6-9",
    sunRequirement: "Shade to Partial Shade",
    matureHeight: "2-4 feet"
  },
  {
    id: 14,
    name: "Purple Coneflower",
    scientificName: "Echinacea purpurea",
    category: "Perennial",
    price: 8.00,
    size: "6\" Pot",
    description: "Native medicinal powerhouse! Attracts pollinators and provides natural immune support. A must-have for any permaculture garden.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/ww1676ya_1000004232.jpg",
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun",
    matureHeight: "2-4 feet"
  },
  {
    id: 15,
    name: "Hardy Ferns Collection",
    scientificName: "Various Species",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    price: 15.00,
    description: "Holly fern, button fern, painted fern, and more! Perfect for shady woodland gardens and adding texture to landscapes.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/yc1519cp_PXL_20240520_124435367.jpg",
    inStock: true,
    growingZones: "4-9",
    sunRequirement: "Shade to Partial Shade",
    matureHeight: "1-3 feet"
  },
  {
    id: 16,
    name: "Lily of the Valley",
    scientificName: "Convallaria majalis",
    category: "Perennial",
    price: 6.00,
    size: "3\" ($6) / 6\" ($10)",
    description: "Classic woodland groundcover with sweetly fragrant white bell-shaped flowers. Spreads to form beautiful colonies.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/err4e5n0_FB_IMG_1769677077182.jpg",
    inStock: true,
    growingZones: "3-8",
    sunRequirement: "Shade to Partial Shade",
    matureHeight: "6-12 inches"
  },
  {
    id: 17,
    name: "Variegated Liriope",
    scientificName: "Liriope muscari",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Versatile groundcover with attractive variegated foliage. Drought tolerant once established.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/fh9fmn04_1000004206.avif",
    inStock: true,
    growingZones: "5-10",
    sunRequirement: "Sun to Shade",
    matureHeight: "12-18 inches"
  },
  {
    id: 18,
    name: "Hardy Orchid",
    scientificName: "Bletilla striata",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Stunning terrestrial orchid that thrives outdoors! Beautiful purple-pink blooms in spring.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/qivizcrn_1000004231.jpg",
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Partial Shade",
    matureHeight: "12-18 inches"
  },
  {
    id: 19,
    name: "Hosta Collection",
    scientificName: "Hosta species",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    price: 15.00,
    description: "Stained Glass, Guacamole, Mouse Ears, Fragrant Bouquet, Hush Puppies, Sum & Substance, Empress Wu, Tiny Gold, Krossa Regal, and more! Many varieties, colors and sizes.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/qc0w28on_FB_IMG_1769677061075.jpg",
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Shade to Partial Shade",
    matureHeight: "6 inches - 4 feet"
  },
  {
    id: 20,
    name: "Hellebores",
    scientificName: "Helleborus orientalis",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Lenten Rose in green/white or pink. Blooms in late winter when little else is flowering. Deer resistant!",
    image: [
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/7pn67is0_1000004258.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/ruumn71i_1000004259.jpg"
    ],
    imageCaption: ["White-green Hellebore in bloom", "Purple Lenten Rose emerging in late winter"],
    inStock: true,
    growingZones: "4-9",
    sunRequirement: "Partial to Full Shade",
    matureHeight: "12-18 inches"
  },
  {
    id: 21,
    name: "Japanese Kerria 'Pleniflora'",
    scientificName: "Kerria japonica 'Pleniflora'",
    category: "Shrub",
    price: 15.00,
    size: "1 Gallon Pot",
    price: 15.00,
    description: "Double-flowering variety with pom-pom like golden yellow blooms on graceful arching branches. Brightens shady areas from spring through early summer.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/qdbeimf7_1000004200.webp",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/7jga3op1_1000004199.webp"
    ],
    imageCaption: ["Double golden blooms", "Graceful spring display"],
    inStock: true,
    growingZones: "4-9",
    sunRequirement: "Partial Shade",
    matureHeight: "3-6 feet"
  },
  {
    id: 22,
    name: "Surprise Lily Bulbs",
    scientificName: "Lycoris radiata",
    category: "Perennial",
    price: 5.00,
    size: "Bare Root Bulb",
    description: "Spectacular red spider lily that blooms in late summer. A magical surprise when they emerge from bare ground!",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/my0jhkcz_FB_IMG_1769679404778.jpg",
    inStock: true,
    growingZones: "6-10",
    sunRequirement: "Partial Shade to Full Sun",
    matureHeight: "12-18 inches"
  },
  {
    id: 23,
    name: "Dwarf Mondo Grass",
    scientificName: "Ophiopogon japonicus",
    category: "Perennial",
    price: 3.00,
    size: "3\" ($3) / 1 Gallon ($8)",
    description: "Sustainable lawn alternative for shady areas. Creates a beautiful, low-maintenance carpet of green.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/63dkqa3y_PXL_20251106_142119758.MP.jpg",
    inStock: true,
    growingZones: "6-10",
    sunRequirement: "Shade to Partial Shade",
    matureHeight: "2-4 inches"
  },
  {
    id: 24,
    name: "Black Mondo Grass",
    scientificName: "Ophiopogon planiscapus 'Nigrescens'",
    category: "Perennial",
    price: 20.00,
    size: "1 Quart",
    description: "Dramatic near-black foliage creates stunning contrast. A collector's plant for unique gardens.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/ccz6075g_1000004230.jpg",
    inStock: true,
    growingZones: "6-10",
    sunRequirement: "Partial Shade",
    matureHeight: "6-8 inches"
  },
  {
    id: 25,
    name: "Sacred Lily",
    scientificName: "Rohdea japonica",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Traditional Japanese good luck plant. Evergreen foliage with red berries in fall.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/knmpi10v_1000004202.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/u8zpfkzz_1000004201.jpg"
    ],
    imageCaption: ["Sacred Lily foliage", "Rohdea japonica berries"],
    inStock: true,
    growingZones: "6-10",
    sunRequirement: "Shade",
    matureHeight: "12-18 inches"
  },
  {
    id: 26,
    name: "Black and Blue Salvia",
    scientificName: "Salvia guaranitica",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Deep blue flowers with black calyxes. Hummingbird magnet! Blooms late summer through frost.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/9qow63ny_1000004203.jpg",
    inStock: true,
    growingZones: "7-10",
    sunRequirement: "Full Sun",
    matureHeight: "3-5 feet"
  },
  {
    id: 27,
    name: "Sedum Collection",
    scientificName: "Sedum species",
    category: "Perennial",
    price: 15.00,
    size: "1 Gallon Pot",
    description: "Thundercloud and Mediovariegatum varieties available. Drought tolerant succulents perfect for rock gardens.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/dirdy410_Sedum-hylotelephium-Thundercloud.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/ztrhjgky_1000004204.jpg"
    ],
    imageCaption: ["Thundercloud", "Mediovariegatum"],
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun",
    matureHeight: "6-24 inches"
  },
  {
    id: 28,
    name: "Tiger Lily",
    scientificName: "Lilium lancifolium",
    category: "Perennial",
    price: 8.00,
    size: "1 Gallon (1 bulb)",
    description: "Classic orange spotted lily. Easy to grow and multiplies readily.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/0fxt7yr3_1000004211.jpg",
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "3-5 feet"
  },

  // ========================================
  // HARDY TROPICALS
  // ========================================
  {
    id: 30,
    name: "Hardy Banana",
    scientificName: "Musa basjoo",
    category: "Hardy Tropical",
    price: 30.00,
    size: "3 Gal ($30) / 7 Gal ($60)",
    description: "The most cold-hardy banana! Creates instant tropical ambiance. Fast-growing with huge paddle-shaped leaves.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/o6so4k58_FB_IMG_1769679390867.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/z5gyeom4_8501b860-1250-4062-a13d-1066dbad5da4-1_all_72.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/ij27e51b_1000004262.jpg"
    ],
    imageCaption: ["Hardy banana plant", "Banana grove at AGreenerSide", "Kids enjoying the tropical banana grove"],
    inStock: true,
    growingZones: "5-10",
    sunRequirement: "Full Sun",
    matureHeight: "12-18 feet"
  },
  {
    id: 31,
    name: "Hardy Butterfly Ginger",
    scientificName: "Hedychium coronarium",
    category: "Hardy Tropical",
    price: 8.00,
    size: "1 Gal ($8) / 3 Gal ($30)",
    description: "Intoxicating fragrance! White butterfly-shaped flowers with heavenly perfume. Returns reliably each year.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/kloe3up0_hedychium2.jpg",
    inStock: true,
    growingZones: "7-11",
    sunRequirement: "Partial Shade to Full Sun",
    matureHeight: "4-6 feet"
  },
  {
    id: 32,
    name: "Giant Hercules Calla Lily",
    scientificName: "Zantedeschia aethiopica",
    category: "Hardy Tropical",
    price: 25.00,
    size: "1 Gallon Pot",
    description: "Impressive giant calla with dramatic arrow-shaped leaves. Elegant white flowers thrive in moist conditions.",
    image: [
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/gm8ausze_FB_IMG_1769677135701.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/99dg2ecy_8501b860-1250-4062-a13d-1066dbad5da4-1_all_702.jpg"
    ],
    imageCaption: ["Giant Hercules Calla Lily in bloom", "Early spring emergence"],
    inStock: true,
    growingZones: "7-10",
    sunRequirement: "Partial Shade to Full Sun",
    matureHeight: "3-4 feet"
  },
  {
    id: 80,
    name: "Water Lily Collections",
    scientificName: "Nymphaea species",
    category: "Hardy Tropical",
    price: 60.00,
    size: "Established Plant",
    description: "Stunning water lilies with vibrant blooms. Perfect for ponds and water gardens. Hardy and reliable, returning year after year. Multiple varieties available.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/8j7jfuna_8501b860-1250-4062-a13d-1066dbad5da4-1_all_2289.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/q1phj0c7_1000004263.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/qf7kepib_1000004265.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/gwnj66d2_1000004302.png"
    ],
    imageCaption: ["Purple Fantasy water lily", "Arc-n-ciel variegated water lily", "Double Red Lotus", "Lotus plants emerging from the pond"],
    inStock: true,
    growingZones: "4-10",
    sunRequirement: "Full Sun",
    matureHeight: "Floating"
  },
  {
    id: 81,
    name: "Variegated Aloe",
    scientificName: "Aloe variegata",
    category: "Rare Houseplant",
    price: 60.00,
    size: "6\" Pot",
    description: "Striking variegated succulent with creamy white and green striped leaves. A rare collector's plant that thrives indoors with minimal care.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/8gs6s39n_8501b860-1250-4062-a13d-1066dbad5da4-1_all_2556.jpg",
    inStock: true,
    growingZones: "9-11 (Indoor anywhere)",
    sunRequirement: "Bright Indirect Light",
    matureHeight: "12-18 inches"
  },

  // ========================================
  // TREES
  // ========================================
  {
    id: 101,
    name: "Bald Cypress",
    scientificName: "Taxodium distichum",
    category: "Tree",
    price: 150.00,
    size: "15 Gallon Pot",
    description: "Iconic deciduous conifer native to wetlands. Beautiful feathery foliage turns russet-bronze in fall. Tolerates wet soil and flooding.",
    image: "https://customer-assets.emergentagent.com/job_agrside/artifacts/kpbamulc_1000004512.jpg",
    inStock: true,
    growingZones: "4-10",
    sunRequirement: "Full Sun",
    matureHeight: "50-70 feet"
  },
  {
    id: 33,
    name: "American Sycamore",
    scientificName: "Platanus occidentalis",
    category: "Tree",
    price: 50.00,
    size: "7 Gallon Pot",
    description: "Majestic native shade tree with distinctive mottled bark. Fast growing and adaptable.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/medfqw6r_1000004237.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/o62gz92w_1000004238.jpg"
    ],
    imageCaption: ["Distinctive mottled sycamore bark", "Majestic American Sycamore in the landscape"],
    inStock: true,
    growingZones: "4-9",
    sunRequirement: "Full Sun",
    matureHeight: "75-100 feet"
  },
  {
    id: 34,
    name: "Chinese Redbud",
    scientificName: "Cercis chinensis",
    category: "Tree",
    price: 35.00,
    size: "3 Gal ($35) / 7 Gal ($65)",
    description: "Stunning spring blooms in vibrant pink-purple. Compact growth habit perfect for small spaces.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/u26tp7h0_1000004208.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/4t8ccket_1000004207.webp"
    ],
    imageCaption: ["Chinese Redbud in full bloom", "Vibrant pink-purple spring blossoms"],
    inStock: true,
    growingZones: "6-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "10-15 feet"
  },
  {
    id: 35,
    name: "Dawn Redwood",
    scientificName: "Metasequoia glyptostroboides",
    category: "Tree",
    price: 150.00,
    size: "15 Gallon Pot",
    description: "Living fossil! Deciduous conifer with beautiful fall color. Fast growing and graceful.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/1ablzjj7_1000004233.avif",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/c4jo5snt_1000004234.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/hv3el331_1000004287.png"
    ],
    imageCaption: ["Dawn Redwood feathery foliage", "Dawn Redwood - the living fossil tree", "Farm cat enjoying the shade of a Dawn Redwood"],
    zoomOutImages: [1],
    inStock: true,
    growingZones: "5-8",
    sunRequirement: "Full Sun",
    matureHeight: "70-100 feet"
  },
  {
    id: 36,
    name: "Ginkgo",
    scientificName: "Ginkgo biloba",
    category: "Tree",
    price: 35.00,
    size: "3 Gal ($35) / 7 Gal ($65) / 15 Gal ($110)",
    description: "Ancient medicinal tree with spectacular golden fall color. Extremely long-lived and pest-free.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/f678hc2d_1000004235.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/9vtgcmhy_1000004236.jpg"
    ],
    imageCaption: ["Spectacular golden ginkgo fall color", "Ginkgo leaves - ancient living fossil"],
    zoomOutImages: [1],
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun",
    matureHeight: "50-80 feet"
  },
  {
    id: 37,
    name: "Southern Magnolia",
    scientificName: "Magnolia grandiflora",
    category: "Tree",
    price: 80.00,
    size: "7 Gal ($80) / 15 Gal ($150)",
    description: "Iconic Southern beauty with glossy evergreen leaves and fragrant white flowers.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/o3qds5he_1000004241.jpg",
    inStock: true,
    growingZones: "6-10",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "60-80 feet"
  },
  {
    id: 38,
    name: "Bigleaf Magnolia",
    scientificName: "Magnolia macrophylla",
    category: "Tree",
    price: 80.00,
    size: "7 Gal ($80) / 15 Gal ($150)",
    description: "Native with the largest leaves of any tree in North America! Massive white fragrant flowers.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/bl0j12c7_1000004209.jpg",
    zoomOut: true,
    inStock: true,
    growingZones: "5-8",
    sunRequirement: "Partial Shade",
    matureHeight: "30-40 feet"
  },
  {
    id: 39,
    name: "Japanese Maple",
    scientificName: "Acer palmatum",
    category: "Tree",
    price: 80.00,
    size: "7 Gallon Pot",
    description: "Elegant red-leafed specimen tree. A focal point in any garden.",
    image: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/bv4iiemz_PXL_20240417_135752160.jpg",
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Partial Shade",
    matureHeight: "15-25 feet"
  },
  {
    id: 40,
    name: "Willow Oak",
    scientificName: "Quercus phellos",
    category: "Tree",
    price: 50.00,
    size: "7 Gallon Pot",
    description: "Graceful native oak with fine-textured willow-like leaves. Fast growing shade tree.",
    image: "https://customer-assets.emergentagent.com/job_agrside/artifacts/tfeejmil_1000004325.jpg",
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Full Sun",
    matureHeight: "60-75 feet"
  },
  {
    id: 41,
    name: "Longleaf Pine",
    scientificName: "Pinus palustris",
    category: "Tree",
    price: 10.00,
    size: "1 Gal ($10) / 3 Gal ($20)",
    description: "Native ecological keystone species. Long needles and distinctive grass stage. Fire adapted.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/a7e9yi22_1000004242.jpg",
    inStock: true,
    growingZones: "7-10",
    sunRequirement: "Full Sun",
    matureHeight: "60-100 feet"
  },
  {
    id: 42,
    name: "Hardy Orange",
    scientificName: "Poncirus trifoliata",
    category: "Tree",
    price: 8.00,
    size: "1 Qt ($8) / 3 Gal ($40) / 7 Gal ($80)",
    description: "The only citrus hardy to zone 5! Fragrant white flowers, edible fruit. Makes an impenetrable hedge.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/c4i7uq25_1000004243.jpg",
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Full Sun",
    matureHeight: "15-20 feet"
  },
  {
    id: 43,
    name: "Birch Trees",
    scientificName: "Betula species",
    category: "Tree",
    price: 80.00,
    size: "7 Gal ($80) / 15 Gal ($150)",
    description: "Sweet Birch and River Birch available. Beautiful bark and graceful habit.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/qo80o7ne_1000004246.jpg",
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "40-70 feet"
  },
  {
    id: 44,
    name: "Tea Camellia",
    scientificName: "Camellia sinensis 'Sochi'",
    category: "Shrub",
    price: 25.00,
    size: "1 Gal ($25) / 2 Gal ($45) / 5 Gal ($75)",
    description: "Grow your own tea! Cold-hardy Russian cultivar. Evergreen with fragrant flowers.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/stf1k7mj_1000004250.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/xwprnpuy_8501b860-1250-4062-a13d-1066dbad5da4-1_all_884.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/ae2vsuue_1000000456.jpg"
    ],
    imageCaption: ["Tea Camellia flowers", "Tea Camellia plants in the greenhouse", "Tea Camellia seedlings"],
    inStock: true,
    growingZones: "6-9",
    sunRequirement: "Partial Shade",
    matureHeight: "6-15 feet"
  },
  {
    id: 45,
    name: "Zelkova",
    scientificName: "Zelkova serrata",
    category: "Tree",
    price: 90.00,
    size: "15 Gallon Pot",
    description: "Excellent elm alternative with vase-shaped canopy. Disease resistant and beautiful fall color.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/z839twdj_Pawpawtreegreenfoliage_2e4a5a00-8090-469c-be05-9c13b390ae61_960x.png",
    inStock: true,
    growingZones: "5-8",
    sunRequirement: "Full Sun",
    matureHeight: "50-80 feet"
  },

  // ========================================
  // FRUIT - BERRIES & SMALL FRUITS
  // ========================================
  {
    id: 46,
    name: "Black Aronia",
    scientificName: "Aronia melanocarpa",
    category: "Shrub",
    price: 50.00,
    size: "7 Gal ($50) / 15 Gal ($80)",
    description: "Superfruit loaded with antioxidants! Native shrub with white spring flowers and brilliant fall color.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/thayovx7_1000004247.webp",
    inStock: true,
    growingZones: "3-8",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "6-8 feet"
  },
  {
    id: 47,
    name: "Pawpaw",
    scientificName: "Asimina triloba",
    category: "Fruit Tree",
    price: 12.00,
    size: "1 Gal ($12) / 3 Gal ($35) / 7 Gal ($80) / 15 Gal ($150)",
    description: "Native custard apple with tropical flavor! Creamy fruit tastes like banana-mango. Plant 2+ for pollination.",
    image: [
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/zpb0ifdt_1000004309.jpg",
      "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/z839twdj_Pawpawtreegreenfoliage_2e4a5a00-8090-469c-be05-9c13b390ae61_960x.png"
    ],
    imageCaption: ["Fresh pawpaw harvest - America's largest native fruit", "Pawpaw tree foliage"],
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Partial Shade to Full Sun",
    matureHeight: "15-25 feet"
  },
  {
    id: 50,
    name: "Blackberry - Navajo",
    scientificName: "Rubus fruticosus",
    category: "Fruit",
    price: 5.00,
    size: "1yr bareroot ($5) / 2yr bareroot ($12)",
    description: "Thornless with excellent flavor. Late ripening extends your harvest season.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/lahw15bf_1000004240.avif",
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Full Sun",
    matureHeight: "4-5 feet"
  },
  {
    id: 51,
    name: "Blueberries",
    scientificName: "Vaccinium corymbosum",
    category: "Fruit",
    price: 15.00,
    size: "1 Gal ($15) / 2 Gal ($25)",
    description: "Duke, Blue Crop, Jersey, and Pink Lemonade varieties. Plant 2+ for best pollination.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/jiv68qgn_1000004248.jpg",
    imageCaption: "Pink Lemonade Blueberry - delicious and attractive",
    inStock: true,
    growingZones: "4-8",
    sunRequirement: "Full Sun",
    matureHeight: "4-6 feet"
  },
  {
    id: 52,
    name: "Kousa Dogwood",
    scientificName: "Cornus kousa",
    category: "Tree",
    price: 75.00,
    size: "7 Gallon Pot",
    description: "Stunning ornamental tree with showy white bracts in late spring and unique raspberry-like edible fruit in fall. Beautiful exfoliating bark adds winter interest.",
    image: [
      "https://customer-assets.emergentagent.com/job_agrside/artifacts/p28duv23_1000004326.jpg",
      "https://customer-assets.emergentagent.com/job_agrside/artifacts/1708n189_1000004327.jpg"
    ],
    imageCaption: ["White spring blooms", "Edible fall fruit"],
    inStock: true,
    growingZones: "5-8",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "15-30 feet"
  },
  {
    id: 53,
    name: "Elderberry",
    scientificName: "Sambucus canadensis",
    category: "Fruit",
    price: 8.00,
    size: "1 Gal ($8) / 3yr bareroot ($25) / 3 Gal ($20)",
    description: "Immune-boosting superfruit! Makes excellent wine, syrup, and jam. Attracts pollinators.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/fe02ca6v_1000004251.jpg",
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "6-12 feet"
  },
  {
    id: 54,
    name: "Fig Trees",
    scientificName: "Ficus carica",
    category: "Fruit Tree",
    price: 12.00,
    size: "1 Gal ($12) / 2 Gal ($20) / 3 Gal ($35) / 7 Gal ($65)",
    description: "Celeste, Turkey, and Italian Honey varieties. Easy to grow with delicious fruit. Can be container grown.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/1saskzns_8501b860-1250-4062-a13d-1066dbad5da4-1_all_1241.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/q93sro72_1000002711.jpg"
    ],
    imageCaption: ["Fig trees laden with fruit", "Fresh figs fresh picked"],
    inStock: true,
    growingZones: "7-10",
    sunRequirement: "Full Sun",
    matureHeight: "10-25 feet"
  },
  {
    id: 55,
    name: "Gooseberry - Captivator",
    scientificName: "Ribes uva-crispa",
    category: "Fruit",
    price: 25.00,
    size: "3 Gallon Pot",
    description: "Nearly thornless! Sweet-tart berries perfect for pies, jams, and fresh eating.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/dj5j9fdl_1000004249.jpg",
    inStock: true,
    growingZones: "3-8",
    sunRequirement: "Partial Shade",
    matureHeight: "3-5 feet"
  },
  {
    id: 56,
    name: "Concord Grapes",
    scientificName: "Vitis labrusca",
    category: "Fruit",
    price: 25.00,
    size: "3 Gal ($25) / 7 Gal ($50)",
    description: "Classic American grape! Perfect for juice, jelly, and wine. Cold hardy and disease resistant.",
    image: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/hfaz3ovh_1000004266.webp",
    inStock: true,
    growingZones: "4-8",
    sunRequirement: "Full Sun",
    matureHeight: "Vine"
  },
  {
    id: 57,
    name: "American Hazelnut",
    scientificName: "Corylus americana",
    category: "Fruit",
    price: 40.00,
    size: "3 Gal ($40) / 7 Gal ($65) / 15 Gal ($150)",
    description: "Native nut producer! Excellent for wildlife and human consumption. Multi-stemmed shrub.",
    image: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/5ydsgpsg_1000004252.jpg",
    inStock: true,
    growingZones: "4-9",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "8-15 feet"
  },
  {
    id: 58,
    name: "Sunchokes",
    scientificName: "Helianthus tuberosus",
    category: "Fruit",
    price: 10.00,
    size: "1 lb ($10) / 3 lb ($25)",
    description: "Jerusalem artichoke! Delicious nutty tubers, beautiful sunflower blooms. Easy to grow perennial vegetable.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/x55jg7e9_PXL_20250624_131707928.jpg",
    inStock: true,
    growingZones: "3-9",
    sunRequirement: "Full Sun",
    matureHeight: "6-10 feet"
  },
  {
    id: 59,
    name: "Honeyberry",
    scientificName: "Lonicera caerulea",
    category: "Fruit",
    price: 20.00,
    size: "1 Gal ($20) / 3 Gal ($50)",
    description: "Rare superfruit! Sweet-tart berries ripen before strawberries. Plant 2+ cultivars for maximum pollination.",
    image: [
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/rvs01gtl_1000001957.jpg",
      "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/pfee05pf_8501b860-1250-4062-a13d-1066dbad5da4-1_all_234.jpg"
    ],
    imageCaption: ["Fresh honeyberry harvest", "Honeyberry plants ready for sale"],
    inStock: true,
    growingZones: "3-8",
    sunRequirement: "Partial Shade to Full Sun",
    matureHeight: "4-6 feet"
  },
  {
    id: 60,
    name: "Hops - Cascade",
    scientificName: "Humulus lupulus",
    category: "Fruit",
    price: 8.00,
    size: "1 Gal ($8) / 2 Gal ($20)",
    description: "Grow your own brew! Classic American aroma hop. Fast-growing ornamental vine.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/atslwaow_1000004245.jpg",
    inStock: true,
    growingZones: "4-8",
    sunRequirement: "Full Sun",
    matureHeight: "15-25 feet vine"
  },
  {
    id: 61,
    name: "Jostaberry",
    scientificName: "Ribes × nidigrolaria",
    category: "Fruit",
    price: 45.00,
    size: "3 Gallon Pot",
    description: "Unique black currant × gooseberry cross. Thornless with large, flavorful dark berries. Highly productive!",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/x1emaf1h_Screenshot_20260129-040412.png",
    inStock: true,
    growingZones: "3-8",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "5-6 feet"
  },
  {
    id: 62,
    name: "Hardy Kiwi",
    scientificName: "Actinidia arguta",
    category: "Fruit",
    price: 60.00,
    size: "3 Gallon Pot",
    description: "Smooth-skinned mini kiwis! No peeling needed. Vigorous vine needs male & female for fruit.",
    image: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/9rtq6auf_1000004267.webp",
    inStock: true,
    growingZones: "4-8",
    sunRequirement: "Full Sun",
    matureHeight: "Vine to 40 feet"
  },
  {
    id: 63,
    name: "Pomegranate",
    scientificName: "Punica granatum",
    category: "Fruit Tree",
    price: 60.00,
    size: "3 Gallon Pot",
    description: "Cold-hardy variety producing ruby-red fruit. Stunning orange-red blooms. Self-fertile.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/uix9u5ua_8501b860-1250-4062-a13d-1066dbad5da4-1_all_285.jpg",
    inStock: true,
    growingZones: "7-10",
    sunRequirement: "Full Sun",
    matureHeight: "8-12 feet"
  },
  {
    id: 64,
    name: "Dwarf Mulberry",
    scientificName: "Morus nigra",
    category: "Fruit Tree",
    price: 45.00,
    size: "3 Gallon Pot",
    description: "Ever-bearing dwarf variety! Sweet black mulberries over extended season. Perfect for containers.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/z839twdj_Pawpawtreegreenfoliage_2e4a5a00-8090-469c-be05-9c13b390ae61_960x.png",
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Full Sun",
    matureHeight: "6-10 feet"
  },
  {
    id: 65,
    name: "Native Pecan",
    scientificName: "Carya illinoinensis",
    category: "Fruit Tree",
    price: 25.00,
    size: "3 Gallon Pot",
    description: "Wild native pecan seedlings. Delicious nuts and beautiful shade tree.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/z839twdj_Pawpawtreegreenfoliage_2e4a5a00-8090-469c-be05-9c13b390ae61_960x.png",
    inStock: true,
    growingZones: "5-9",
    sunRequirement: "Full Sun",
    matureHeight: "70-100 feet"
  },
  {
    id: 66,
    name: "Raspberry - Red & Gold",
    scientificName: "Rubus idaeus",
    category: "Fruit",
    price: 15.00,
    size: "1 Gallon Pot",
    price: 15.00,
    description: "Red and Gold varieties available. Ever-bearing for extended harvest season.",
    image: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/91thh4m2_PXL_20250520_230047670.MP.jpg",
    inStock: true,
    growingZones: "4-8",
    sunRequirement: "Full Sun",
    matureHeight: "4-6 feet"
  },
  {
    id: 67,
    name: "White Strawberry",
    scientificName: "Fragaria × ananassa",
    category: "Fruit",
    price: 3.00,
    size: "4\" Pot",
    description: "Unique pineapple-flavored white strawberry! Novelty fruit for the adventurous gardener.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/vl9350p8_1000004239.jpg",
    inStock: true,
    growingZones: "4-8",
    sunRequirement: "Full Sun",
    matureHeight: "6-12 inches"
  },

  // ========================================
  // SPECIALTY PLANTS
  // ========================================
  {
    id: 75,
    name: "Giant Moso Bamboo",
    scientificName: "Phyllostachys edulis",
    category: "Perennial",
    price: 80.00,
    size: "7 Gallon Pot",
    description: "The largest temperate bamboo! Excellent for privacy screens, windbreaks, and sustainable timber.",
    image: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/6y2fpoa3_FB_IMG_1769679418823.jpg",
    inStock: true,
    growingZones: "6-10",
    sunRequirement: "Full Sun to Partial Shade",
    matureHeight: "40-75 feet"
  },

  // ========================================
  // CLASSES & WORKSHOPS
  // ========================================
  {
    id: 83,
    name: "Circle Hammock",
    scientificName: "Handcrafted",
    category: "Workshop",
    price: 200.00,
    size: "Workshop or Finished Product",
    description: "Learn the art of weaving your own circle hammock in our hands-on workshop, or purchase a beautifully handcrafted finished piece. Perfect for relaxing in your garden sanctuary.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/6k90op8g_8501b860-1250-4062-a13d-1066dbad5da4-1_all_993.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/btwxfigk_8501b860-1250-4062-a13d-1066dbad5da4-1_all_998.jpg",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/bqyhuo4b_8501b860-1250-4062-a13d-1066dbad5da4-1_all_37.jpg"
    ],
    imageCaption: ["Circle hammock workshop", "Finished circle hammock", "Enjoying the hammock swing"],
    inStock: true,
    growingZones: "N/A",
    sunRequirement: "N/A",
    matureHeight: "N/A"
  },
  {
    id: 84,
    name: "Traditional Woodworking - Shingle Making",
    scientificName: "Old School Techniques",
    category: "Workshop",
    price: 75.00,
    size: "Half-Day Workshop",
    description: "Learn the old school traditional woodworking techniques that roofed our ancestors' homes. Master the art of hand-splitting wooden shingles using time-honored methods with a froe, mallet, and drawknife. Connect with craftsmanship of the past.",
    image: [
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/f2846l92_1000004255.png",
      "https://customer-assets.emergentagent.com/job_greenerside/artifacts/pnvrz3kx_1000004256.png"
    ],
    imageCaption: ["Hand-split wooden shingles with traditional froe", "Traditional shingle-making setup"],
    inStock: true,
    growingZones: "N/A",
    sunRequirement: "N/A",
    matureHeight: "N/A"
  }
];
